export const LIGHT_YELLOW = "#FFDA54";
export const OPAQUE_LIGHT_YELLOW = "#FFDA5499";
export const YELLOW = "#E88C00";
export const AMBER = "#FFBF00";

export const LIGHT_PINK = "#E291AE";
export const OPAQUE_LIGHT_PINK = "#E291AE99";
export const PINK = "#DA1A5D";
export const OPAQUE_PINK = "#9F244F";

export const BLUE = "#445ffe";
export const OPAQUE_BLUE = "#3640a2";
export const MEDIUM_BLUE = "#0070D7";
export const OPAQUE_MEDIUM_BLUE = "#0070D799";
export const LIGHT_BLUE = "#768aff";
export const PURPLE_BLUE = "#B388FF";
export const LOW_BLUE = "#9FADFF";
export const OPAQUE_LIGHT_BLUE = "#9FADFF99";
export const DARK_BLUE = "#474E5A";

export const RED = "#FF6B6B";
export const LIGHT_RED = "#FFCED3";
export const OPAQUE_RED = "#FF6B6B99";
export const MEDIUM_RED = "#FF5454";
export const OPAQUE_MEDIUM_RED = "#FF545499";
export const STRONG_RED = "#E43030";

export const ORANGE = "#FFB054";
export const LIGHT_ORANGE = "#FFE9BE";
export const OPAQUE_ORANGE = "#FFB05499";
export const STRONG_ORANGE = "#f09224";

export const AQUA_GREEN = "#12C2A5";
export const GREEN = "#63DC76";
export const LIGHT_GREEN = "#D2FFCE";
export const OPAQUE_GREEN = "#63DC7699";
export const STRONG_GREEN = "#0BB000";

export const WHITE = "#FFFFFF";
export const NEAR_WHITE = "#F2F2F2";
export const LOW_GRAY = "#BDBDBD";
export const SILVER = "#A6A9B1";
export const LIGHTER_GRAY = "#999999";
export const LIGHT_GRAY = "#828282";
export const MEDIUM_GRAY = "#666666";
export const CARBON_GRAY = "#535861";
export const GRAY = "#434343";
export const DARK_GRAY = "#4f4f4f";
export const DINGY_GRAY = "#333333";
export const FROSTED_BLACK = "#282828";
export const MATTE_BLACK = "#262626";
export const NEAR_BLACK = "#191919";
export const BLACK = "#000000";

export const TRANSPARENCY_SUFFIX_IN_HEX = "44";
export const TRANSPARENCY_32_PERCENT_SUFFIX_IN_HEX = "53";
